import styled from '@emotion/styled';
import {ReactComponent as AddSVG} from '../../../../../../assets/icons/ic_add.svg';

export const CardRequestNewLoanWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: ${({theme}) => theme.padding.desktop.md};
  gap: ${({theme}) => theme.gap.desktop.lg};
`;

export const IconAdd = styled(AddSVG)`
  width: ${({theme}) => theme.icon.size.md};
  height: ${({theme}) => theme.icon.size.md};
  fill: ${({theme}) => theme.color.white};
`;
